<template>
  <div>
  <vehicle-detail :is-edit="true" :is-new="this.isNew"/>
  <b-row>
    <DriverHistorie v-bind:vehicle_id="this.id"></DriverHistorie>
  </b-row>
  </div>
</template>

<script>
    import VehicleDetail from './components/VehicleDetail';
    import driverHistorieList from "@/views/vehicleManagement/vehicle/components/driverHistorieList";

    export default {
        name: "EditVehicle",
        components: {
            VehicleDetail,
            'DriverHistorie': driverHistorieList
        },
        props: {
            id: String,
            isNew: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style scoped>

</style>
